<script>
  import pick from "lodash/pick";
  import SelectInput from "#lib/sidebar/SelectInput.svelte";
  import productSpecs from "#src/extensions/product-specs.js";
  import cloneDeep from "lodash/cloneDeep";
  import { createType as defaultType, hydrateType, hydrateMaterial } from "@local/lamina-core";
  import { api } from "#src/api";
  import { typeSurfaces } from "@local/lamina-core";

  export let group;
  export let types;
  export let border;
  export let label = "Label";
  /** @type {string | null} */
  export let labelWidth = null;
  export let value;
  export let product;
  export let options = [];

  let specOptions = [];

  $: productOptions = options.map((p) => ({
    label: p.name,
    value: p.id,
  }));
  $: specs = productSpecs(product);
  $: surfaces = typeSurfaces(product);
  $: updateSpecOptions(specs);

  function specName(spec) {
    if (spec.path === "material") {
      if (surfaces.length === 3 && surfaces[1] == null) {
        if (spec.index === 0) {
          return "Outer Material";
        } else if (spec.index === 2) {
          return "Inner Material";
        }
      } else if (surfaces.length === 1) {
        const layer = product.data.layers?.[0];
        if (layer?.type === "glass") {
          return "Glass";
        }

        return "Material";
      }

      return `Layer ${spec.index + 1} Material`;
    } else if (spec.path === "outboard_surface") {
      return `#${surfaces[spec.index]} Surface`;
    } else if (spec.path === "inboard_surface") {
      return `#${surfaces[spec.index] + 1} Surface`;
    }

    return spec.name;
  }

  function updateProduct(evt) {
    const id = evt.detail.value;
    const p = options.find((o) => o.id === id);
    if (!p) return;

    product = hydrateType({
      ...defaultType($group.id, types),
      ...pick(p, [
        "description",
        "name",
        "image",
        "category",
        "category_id",
        "item_template",
        "item_template_mask",
        "use_item_drawing_as_thumbnail",
        "use_type_image_as_thumbnail",
        "pricing_group",
        "freight_group",
      ]),
      data: cloneDeep(p.expanded_data),
      product_spec: p.data,
      product_id: product?.id,
    });
  }

  function selectedSpec(spec, product) {
    const layer = product.data.layers?.[spec.index];
    const prod = layer?.[spec.path];
    return prod?.id;
  }

  function selectSpec(spec, specIndex, value) {
    const layer = product.data.layers?.[spec.index];
    const prod = layer?.[spec.path];
    if (!prod) return;

    const so = specOptions[specIndex];
    const o = so.find((s) => s.id === value);

    layer[spec.path] = {
      ...layer[spec.path],
      ...o,
    };

    if (!product.data.meta_parameters) {
      product.data.meta_parameters = [];
    }
    product.data.meta_parameters.push({
      path: `data.layers.${spec.index}.${spec.path}.id`,
      value,
    });

    product = product;
  }

  async function updateSpecOptions(specs) {
    let so = [];
    if (specs.length) {
      const results = await Promise.all(
        specs.map((spec) => api.rpc("product_query_options", { makeup: spec.makeup })),
      );

      so = results.map((res) => {
        if (res.data) {
          return res.data.map((d) => {
            if (d.application === "material") hydrateMaterial(d);
            return d;
          });
        } else {
          return null;
        }
      });
    }

    specOptions = so;
  }
</script>

<div class="space-y-2">
  {#if productOptions.length > 1}
    <SelectInput {border} {label} {labelWidth} bind:value options={productOptions} on:input={updateProduct} />
  {/if}
  {#each specs as spec, specIndex}
    {@const so = specOptions[specIndex]}
    {@const selected = selectedSpec(spec, product)}
    {#if so?.length}
      <SelectInput
        {border}
        {labelWidth}
        label={specName(spec)}
        value={selected}
        options={so.map((o) => ({ label: o.name, value: o.id }))}
        on:input={(e) => selectSpec(spec, specIndex, e.detail.value)} />
    {/if}
  {/each}
</div>
